import React from "react";
import { GH_COLORS } from "./Style";

interface DayLineProps {
  left: number;      // 수직선 위치 (픽셀)
  labelLeft: number; // 라벨 중앙 위치 (픽셀)
  label: string;     // 요일 레이블 텍스트
  top: number;
  height: number;
}

const DayLine: React.FC<DayLineProps> = ({
  left,
  labelLeft,
  label,
  top,
  height,
}) => {
  return (
    <div>
      {/* 요일 라벨 */}
      <div
        style={{
          position: "absolute",
          left: `${labelLeft}px`,
          top: `${top - 24}px`,
          transform: "translateX(-50%)",
          fontSize: 12,
          fontWeight: 600,
          color: "#555",
          width: 20,
          textAlign: "center",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </div>

      {/* 수직 라인 */}
      <div
        style={{
          position: "absolute",
          left: `${left}px`,
          top: `${top}px`,
          width: 0,
          height: `${height}px`,
          borderLeft: `1px solid ${GH_COLORS.border}`,
        }}
      />
    </div>
  );
};

export default DayLine;
